import { render, staticRenderFns } from "./copyConfig.vue?vue&type=template&id=431c4f38"
import script from "./copyConfig.vue?vue&type=script&lang=js"
export * from "./copyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports